import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

export const RESOURCE = {
  payload: {
    description:
      'A physical structure containing floors and rooms with facilities used for research, instruction, and administration.',
    dimension: space.RESOURCE.payload,
    level: 1,
    name: 'Building',
    partialId: PartialId.Standard.create('bldg'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
